import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { PackageCountUpdate } from "../../services/Cart/getCartPackage";

const PackagePriceUpdateModal = ({
  packagePriceUpdateModalVisible,
  setPackagePriceUpdateModalVisible,
  sendDataToPackageUpdateModal,
  storeId,
  storeCustomerId,
  selectedPackageItemValue,
  bookingOrderId,
}) => {
  let count = parseFloat(0.1);
  const [totalPackageCountValue, setTotalPackageCountValue] = useState(1);
  const [totalPackagePriceValue, setTotalPackagePriceValue] = useState(0);

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    if (selectedPackageItemValue) {
      const itemCountOriginal = selectedPackageItemValue.itemCount;
      const countGramOriginal = selectedPackageItemValue.countGram;
      const totalCountOriginal = itemCountOriginal + countGramOriginal;
      setTotalPackageCountValue(totalCountOriginal);
      setTotalPackagePriceValue(selectedPackageItemValue?.offerPrice)
    }
  }, [selectedPackageItemValue]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");
  const [packagePriceError, setPackagePriceError] = useState("");


  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  let itemCount = 0;
  let countGram = 0;
  if (selectedPackageItemValue?.packageDTO.serviceUnit === "Kg") {
    const value = totalPackageCountValue;
    itemCount = Math.floor(value);
    countGram = parseFloat((value - itemCount).toFixed(2));
  } else {
    const value = totalPackageCountValue;
    itemCount = Math.floor(value);
    countGram = parseFloat((value - itemCount).toFixed(2));
  }

  const handleTotalPackageCountSubmit = () => {
    if (totalPackagePriceValue === 0) {
      setErrorText("Entered Value Must Be Greater Then Zero");
    } else if (totalPackageCountValue === 0) {
      setErrorText("Entered Value Must Be Greater Then Zero");
    } else {
      setIsSubmitButtonPressed(true);
      const value = totalPackagePriceValue;
      let itemCount = 0;
      let countGram = 0;
      if (selectedPackageItemValue?.packageDTO.serviceUnit === "Kg") {
        const value = totalPackageCountValue;
        itemCount = Math.floor(value);
        countGram = parseFloat((value - itemCount).toFixed(2));
      } else {
        const value = totalPackageCountValue;
        itemCount = Math.floor(value);
        countGram = parseFloat((value - itemCount).toFixed(2));
      }
      const data = {
        ...selectedPackageItemValue,
        itemCount: itemCount,
        countGram: countGram,
        offerPrice: Number(value),
      };

      PackageCountUpdate(
        storeCustomerId,
        storeId,
        bookingOrderId,
        selectedPackageItemValue.id,
        data
      )
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            sendDataToPackageUpdateModal({
              success: true,
            });
            if (Res.status === true) {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(Res.message);
            } else {
              setModalVisible(true);
              setModalStatus("failed");
              setModalText(Res.message);
            }
            setPackagePriceUpdateModalVisible(false);
            setIsSubmitButtonPressed(false);
            setErrorText("");
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const handlePackageCountChange = (text) => {
    if (text === "") {
      // Handle clearing the input field
      setTotalPackageCountValue("");
      setErrorText("Total cannot be Empty or Zero");
      setIsSubmitButtonPressed(true);
    } else {
      const newPackageCount = text;
      setTotalPackageCountValue(newPackageCount);
      const parsedValue = parseFloat(newPackageCount);

      if (!isNaN(parsedValue)) {
        setErrorText("");
        setIsSubmitButtonPressed(false);
      } else {
        // Handle invalid input
        setIsSubmitButtonPressed(true);
        setErrorText("Please Enter Correct Value");
      }
    }
  };

  const handlePackagePriceChange = (text) => {

    const inputRegex = /^\d*$/;

    if (!inputRegex.test(text)) return;

    if (text === "") {
      // Handle clearing the input field
      setTotalPackagePriceValue("");
      setErrorText("Price cannot be Empty or Zero");
    } else {
      // Allow only valid numeric input including leading zeros and decimals
      const newPackagePrice = text;
      setTotalPackagePriceValue(newPackagePrice);
      const parsedValue = parseInt(newPackagePrice);
      if (!isNaN(parsedValue)) {
        setErrorText("");
      } else {
        // Handle invalid input
        setErrorText("Please Enter Correct Value");
      }
    }
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    setPackagePriceUpdateModalVisible(false);
    setTotalPackageCountValue(parseFloat(count.toFixed(2)));
    setErrorText("");
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={packagePriceUpdateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!packagePriceUpdateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif"}
                  style={{
                    width: 40,
                    height: 40,
                  }}
                />
              </div>

              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Package Price
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            {!selectedPackageItemValue?.packageDTO?.carryForward && 
              <div className="flex-1 flex justify-content-center align-items-center">
                <div className="mr-3">
                  <p className="text-2xl font-bold uppercase">Price : </p>
                </div>
                <div
                  className=" border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                >

                  <div>
                    <InputText
                      value={totalPackagePriceValue}
                      maxLength={50}
                      onChange={(e) =>
                        handlePackagePriceChange(e.target.value)
                      }
                      className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                    ></InputText>

                    {packagePriceError !== "" && (
                      <p>{packagePriceError}</p>
                    )}
                  </div>

                </div>
            </div>}

             
            <div className="flex-1 flex justify-content-center align-items-center">

              {errorText !== "" && (
                <p className="text-xl font-normal" style={{ color: "red" }}>
                  {errorText}
                </p>
              )}
            </div>

            <Button
              disabled={isSubmitButtonPressed}
              onClick={handleTotalPackageCountSubmit}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                Update
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default PackagePriceUpdateModal;
